import LegalPage from './LegalPage';
import { refundBlocks } from './legalBlocks';

export default function RefundPage() {
  return <LegalPage blocks={refundBlocks} />;
}
